module.exports = __webpack_public_path__ + "img/dark_right_tag.2fb7b21d.png";